import React from 'react'
import {Link} from 'gatsby'
export default function ContactButton() {
    return (
    <Link style={{fontFamily: "Josefin sans, sans-serif", color: "white", textTransform: "uppercase"}} className='py-2 px-4 btnColor no-underline my-2 ' to='/#contact'>Contact Us</Link>
    )
}
